import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "services/apiList";

const initialState = {
  loading: false,
  user: JSON.parse(
    window.localStorage.getItem("user") === undefined ||
      window.localStorage.getItem("user") === "undefined"
      ? ""
      : window.localStorage.getItem("user")
  ),

  forgot: { activeStepIndex: 0 },
  error: "",
};

export const fetchLoginUser = createAsyncThunk("post/login", async (body) => {
  const response = await axios.post(ApiList.loginUrl, body);
  return response.data;
});

export const fetchForgotToken = createAsyncThunk(
  "post/forgot_token",
  async (body) => {
    const response = await axios.post(ApiList.forgotTokenUrl, body);
    return response.data;
  }
);

export const fetchForgotTokenCheck = createAsyncThunk(
  "post/forgot_token_check",
  async (body) => {
    const response = await axios.post(ApiList.forgotTokenCheckUrl, body);
    return response.data;
  }
);

export const fetchForgotPasswordChange = createAsyncThunk(
  "post/forgot_password_change",
  async (body) => {
    const response = await axios.post(ApiList.forgotPasswordChangeUrl, body);
    return response.data;
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    loginUser: (state, action) => {
      state.user = action.payload;
      window.localStorage.setItem("user", JSON.stringify(state.user));
    },

    logoutUser: (state, action) => {
      state.user = null;
      window.localStorage.setItem("user", null);
    },
    setActiveStepIndex: (state, action) => {
      state.activeStepIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        if (action.payload && action.payload.result)
          state.user = action.payload.result;
        window.localStorage.setItem("user", JSON.stringify(state.user));
        state.error = "";
      })
      .addCase(fetchLoginUser.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      });

    builder
      .addCase(fetchForgotToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchForgotToken.fulfilled, (state, action) => {
        state.loading = false;
        state.forgot.activeStepIndex = 1;
        state.error = "";
      })
      .addCase(fetchForgotToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchForgotTokenCheck.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchForgotTokenCheck.fulfilled, (state, action) => {
        state.loading = false;
        state.forgot.activeStepIndex = 2;
        state.error = "";
      })
      .addCase(fetchForgotTokenCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchForgotPasswordChange.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchForgotPasswordChange.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(fetchForgotPasswordChange.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { loginUser, logoutUser, setActiveStepIndex } = authSlice.actions;
export default authSlice.reducer;
export const currentUser = (state) => state.auth.user;
